var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgMuscleAndShred(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 33,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16.563.998h-2.865c-.602 0-1.178.24-1.603.665-.39.392-.909.62-1.457.69-3.161.406-7.633 2.083-6.56 6.33.2.79.191 1.64-.165 2.373-.666 1.368-1.387 3.197-1.4 4.475-.004.49.303.903.685 1.21l.802.644c1.015.814 2.5.745 3.28-.295.569-.758 1.04-1.555 1.04-2.092 0-1.259 1.86 2.463.674 9.318a1.52 1.52 0 00-.024.455c.087.66.535 1.945 1.804 3.449.437.517 1.096.778 1.773.778h4.016"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M16.465.998h2.865c.601 0 1.178.24 1.602.666.39.391.91.619 1.457.69 3.161.406 7.634 2.082 6.56 6.329-.2.79-.19 1.64.166 2.373.665 1.368 1.386 3.197 1.399 4.475.004.49-.303.903-.685 1.21l-.802.644c-1.014.814-2.499.745-3.28-.295-.569-.757-1.04-1.554-1.04-2.092 0-1.259-1.86 2.463-.674 9.318.026.15.044.304.024.455-.087.66-.534 1.945-1.804 3.45-.437.516-1.096.777-1.773.777h-4.015M11.422 16.27h4.364M11.422 20.089h4.364M11.422 23.907h4.364M17.24 16.27h4.364M17.24 20.089h4.364M17.24 23.907h4.364"
  })));
}

export default SvgMuscleAndShred;